import React from 'react';
import Select from 'react-select';

const customStyles = {
  control: (base) => ({
    ...base,
    background: '#fff',
    borderRadius: '8px',
    border: '0',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
    padding: '4px 13px',
    paddingRight: '6px',
    fontSize: '16px',
    fontFamily: 'Roboto, sans-serif',
    cursor: 'pointer',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#eaffdd'
      : state.isFocused
      ? '#daf9e4'
      : '#fff',
    color: state.isSelected ? '#197547' : '#000',
    padding: '10px 13px',
    fontSize: '16px',
    fontFamily: 'Roboto, sans-serif',
    cursor: 'pointer',
  }),
  menu: (base) => ({
    ...base,
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
  }),
  singleValue: (base) => ({
    ...base,
    color: '#000',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: '#aaa',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
};

const Dropdown = ({ options, value, onChange, placeholder, isMulti = false }) => {
  return (
    <Select
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      isMulti={isMulti}
      styles={customStyles}
    />
  );
};

export default Dropdown;